import type Phaser from 'phaser';
import { saveGame } from './state/save';
import { setMuted } from './audio/sfx';

/**
 * iOS/PWA lifecycle: autosave + pause + mute when the app is hidden
 * (visibilitychange/pagehide), and resume cleanly when shown again.
 */
export function installLifecycle(game: Phaser.Game): void {
  const hide = (): void => {
    saveGame();
    setMuted(true);
    game.sound.mute = true;
    if (game.scene.isActive('World')) game.scene.pause('World');
    game.loop.sleep();
  };

  const show = (): void => {
    game.loop.wake();
    setMuted(false);
    game.sound.mute = false;
    if (game.scene.isPaused('World')) game.scene.resume('World');
  };

  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'hidden') hide();
    else show();
  });

  // pagehide is the reliable "app is going away" signal on iOS Safari.
  window.addEventListener('pagehide', () => {
    saveGame();
  });
}
